import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({ name: 'getProductName' })
export class getProductName implements PipeTransform {
  transform(variable: Array<string>): any {
    if (environment.inheritProductName === '') {
      return environment.product;
    } else if (variable.includes(environment.product)) {
      return environment.product;
    } else {
      return environment.inheritProductName;
    }
  }
}
